import React, { Component, Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../components/global/Header';
// import Footer from '../components/global/Footer';
import PropTypes from 'prop-types';
import { towItemsData, getFiltersData, getCarbonFiltersData, getCigaretteData, getCarbonCigaretteData, getEpdData, getPlugwrapData } from '../actions';
import routes from '../routes';
//import Error from './../containers/Error';
// import { throws } from 'assert';


class PrimaryLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorHandler: '',
            userRole: this.props.userRole || ''
        };
    }
    componentDidMount() {
        if (navigator.userAgent.match(/Trident.*rv[ :]*11\./) && !(window.ActiveXObject) && "ActiveXObject") {
            document.body.classList.add('ie11');
        }
    }
    componentWillMount() {
        getFiltersData().then(res => {
            return res;
        });
        getCarbonFiltersData().then(res => {
            return res;
        });
        getCigaretteData().then(res => {
            return res;
        });
        getCarbonCigaretteData().then(res => {
            return res;
        });
        getPlugwrapData().then(res => {
            return res;
        });
        getEpdData().then(res => {
            return res;
        });
    }
    render() {
        let towItemsData = this.props.itemData;
        let routeFound = true;
        for(let i=0; i< routes.length; i++) {
            if(routes[i] !== this.props.location.pathname) {
                routeFound = false;
            }
        }
        const { location } = this.props;
        return (
            <Fragment>
                <div className="primary-layout">
                    { this.props.location.pathname !== '/login' && this.props.location.pathname !== '/404' && this.props.location.pathname !== '/inprogress' && this.props.location.pathname !== '/403' && this.props.location.pathname !== '/company-not-found' ? <Header location={location} /> : null }
                    <div className="main">
                        <Switch location={location}>
                            {
                                this.state.userRole && towItemsData.error ? 
                                this.props.location.pathname !== '/company-not-found' && <Redirect to={{ pathname: '/company-not-found', state: { errorHandler: towItemsData} }} /> : null
                            }
                            { routes && routes.map((val, ind) => {
                                    if(this.state.userRole.toLocaleLowerCase() === 'admin') {
                                        return (
                                            <Route key={ind} path={val.path} exact={val.exact} component={val.component} />
                                        )
                                    } else {
                                        if(val.isAdmin) {
                                            return null;
                                        } else {
                                            return (
                                                <Route key={ind} path={val.path} exact={val.exact} component={val.component} />
                                            )
                                        }
                                    }
                                })
                            }
                            {
                                this.state.userRole.toLocaleLowerCase() === 'admin' ? 
                                    ( routeFound ? <Redirect to={`${this.props.location.pathname}`} /> : <Redirect to='/404' />)
                                : <Redirect to='/403' />
                            }
                            {/* <Redirect to='/404' /> */}
                        </Switch>
                        <div className="cigarette-image-load">
                            <img src="./images/tow.svg" alt="tow-img" />
                            <img src="./images/orange_tip.svg" alt="tow-img" />
                            <img src="./images/cigarette.png" alt="tow-img" />
                        </div>
                    </div>
                    {/* <Footer></Footer> */}
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState, towItemsState }) => ({
    prefData: loggedUserState.prefData,
    userRole: loggedUserState.userRole,
    itemData: towItemsState.itemData
});

const mapDispatchToProps = dispatch => ({
    towItemsData: (data) => dispatch(towItemsData(data))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrimaryLayout);

PrimaryLayout.propTypes = {
    match: PropTypes.object,
    towItemsData: PropTypes.func,
    location: PropTypes.object,
    prefData: PropTypes.object,
    userRole: PropTypes.string,
    itemData: PropTypes.any,
    getFiltersData: PropTypes.func,
    getCarbonFiltersData: PropTypes.func,
    getCigaretteData: PropTypes.func,
    getCarbonCigaretteData: PropTypes.func,
    getPlugwrapData: PropTypes.func,
    getEpdData: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/Layouts/PrimaryLayout.js